import React, { useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import SidebarV2NavItem from './SidebarV2NavItem'
import { NavigationContext } from '../../NavigationContext'

const useStyles = makeStyles(() => ({
    sidebar: {
        width: '78px',
        minWidth: '78px',
        paddingBottom: '15px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: '#002119',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '4px',
            backgroundColor: 'transparent'
        }
    },
    navItemList: {
        display: 'flex',
        flexDirection: 'column'
    }
}))

/**
 * Displays the top-level nav items in a green, vertical sidebar
 */
const SidebarV2 = () => {
    const classes = useStyles()

    const { getNavItems } = useContext(NavigationContext)

    const topLevelNavItems = getNavItems()

    return (
        <div className={classes.sidebar}>
            {[
                topLevelNavItems.filter(n => !n.pinned),
                topLevelNavItems.filter(n => n.pinned)
            ].map((navItemList, listIndex) => (
                <div key={listIndex} className={classes.navItemList}>
                    {navItemList.map(navItem => (
                        <SidebarV2NavItem
                            key={navItem.id}
                            navItem={navItem}
                        />
                    ))}
                </div>
            ))}
        </div>
    )
}

export default SidebarV2
